export default class MenuModel {
    constructor({ pathname, title, active }) {
        this.title = title;
        this.pathname = pathname;
        if (active) this.active = active.bind(this);
    }
}
  